import "../sass/main.scss";
import './utils/cookie-manager';
import './raf';

import './components/modal-no-scroll-fix';
import './init';
import './components/video';
import './components/audio-player';
import './components/audio-list-player';
import './components/watch-carousel';
import './components/search';
import './components/announcement';
import './components/modal-menu';
import './components/modal';
import './sliders';
import "swiper/modules/scrollbar/scrollbar.scss"
import "swiper/modules/free-mode/free-mode.scss"
